"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".full-width{width:100%}.create-button{font-size:16px;font-weight:700}.additional-login-dialog-title{font-weight:700}.login-dialog-backdrop .mat-dialog-content{overflow-y:hidden!important}"];
exports.styles = styles;
